module.exports = __webpack_public_path__ + "img/bars.9be34e62.svg";